import React from "react";
import { X } from "@phosphor-icons/react";
import { BLANK_CONFIG, TYPE_META } from "@/components/delivery/destinationConstants";
import { TypeSpecificFields } from "@/components/delivery/DestinationForm";

export const blankPlace = (to = "") => ({ type: "email", config: { ...BLANK_CONFIG, to }, own_field_list: false });

// One extra delivery place: where it goes, its settings, and whether it gets its own field list.
export function ExtraPlaceForm({ value, onChange, onRemove, testId }) {
  const set = (patch) => onChange({ ...value, ...patch });
  const setConfig = (k, v) => set({ config: { ...value.config, [k]: v } });
  return (
    <div className="border-2 border-black bg-zinc-50 p-3" data-testid={testId}>
      <div className="mb-2 flex items-center gap-2">
        <span className="label-mono">Also send to</span>
        {onRemove && (
          <button type="button" onClick={onRemove} className="ml-auto" aria-label="Remove this place" data-testid={`${testId}-remove`}>
            <X size={14} weight="bold" />
          </button>
        )}
      </div>
      <div className="mb-3 grid grid-cols-2 gap-2 sm:grid-cols-4">
        {Object.entries(TYPE_META).map(([type, m]) => (
          <button key={type} type="button" onClick={() => set({ type })} title={m.help}
                  className={`flex items-center gap-1.5 border-2 border-black p-2 text-left text-[11px] transition-colors duration-100 ${value.type === type ? "bg-black text-white" : "bg-white hover:bg-zinc-100"}`}
                  data-testid={`${testId}-type-${type}`}>
            <m.Icon size={14} weight="bold" /> {m.label}
          </button>
        ))}
      </div>
      <div className="grid grid-cols-2 gap-4">
        <TypeSpecificFields type={value.type} config={value.config} setConfig={setConfig} extraPlace />
      </div>
      <label className="mt-3 flex items-center gap-2 text-xs">
        <input type="checkbox" checked={!value.own_field_list} onChange={(e) => set({ own_field_list: !e.target.checked })} data-testid={`${testId}-same-fields`} />
        Send the same fields as the main delivery (untick to pick a separate list for this place)
      </label>
    </div>
  );
}
